import {useEffect, useState} from 'react';

import {
  AIDocumentOptions,
  ESG_PRODUCT,
  getAIDocumentOptions
} from '../services/modules/AIDocumentManager/aiDocumentsAPI';

export interface SelectOption {
  label: string;
  value: string;
}

const toOption = (item: any): SelectOption => {
  if (typeof item === 'string') {
    return {label: item, value: item};
  }

  const value = item?.code ?? item?.value ?? '';

  return {label: item?.label ?? value, value};
};

export const useAIDocumentOptions = (): {
  options: AIDocumentOptions | null;
  frameworkOptions: SelectOption[];
  documentTypeOptions: (framework?: string) => SelectOption[];
} => {
  const [options, setOptions] = useState<AIDocumentOptions | null>(null);

  useEffect(() => {
    let active = true;

    getAIDocumentOptions()
      .then((res) => {
        if (active) {
          setOptions(res);
        }
      })
      .catch(() => {});

    return () => {
      active = false;
    };
  }, []);

  const frameworkOptions = (options?.frameworks ?? [])
    .filter(
      (item) =>
        typeof item === 'string' ||
        !item?.product ||
        item.product === ESG_PRODUCT
    )
    .map(toOption);

  const documentTypeOptions = (framework?: string): SelectOption[] =>
    (options?.document_types ?? [])
      .filter(
        (doc) =>
          doc.product === ESG_PRODUCT &&
          (!framework || doc.framework === framework)
      )
      .map((doc) => ({label: doc.label, value: doc.code}));

  return {options, frameworkOptions, documentTypeOptions};
};
